const RADIANS_PER_DEGREE = Math.PI / 180.0;
const WGS84_E = 0.0818191908;
const WGS84_A = 6378137.0;
const UTM_K0 = 0.9996;
const SOUTH_HEMISPHERE_OFFSET = 10000000.0;
const UTM_E2 = (WGS84_E * WGS84_E);
const DEGREES_PER_RADIAN = 180.0 / Math.PI;

const kZcsEncryptSalt = 0x8bbeb8eafcb9887cn;
const kZcsBitMask32 = 0xffffffffn;
const kZcsBitCount32 = 32n;
//#region  public function
export function ZCSToWGS84(zcs_x: string, zcs_y: string) {
    let uint_x = BigInt.asUintN(64, bswap_64(zcs_x));
    let uint_y = BigInt.asUintN(64, bswap_64(zcs_y));
    uint_x ^= kZcsEncryptSalt;
    uint_y ^= kZcsEncryptSalt;
    let x_xor_factor = ((uint_y & kZcsBitMask32) << kZcsBitCount32);
    let y_xor_factor = ((uint_x & kZcsBitMask32) << kZcsBitCount32);
    uint_x ^= x_xor_factor;
    uint_y ^= y_xor_factor;
    let uint_x_buffer = new ArrayBuffer(8);
    let uint_y_buffer = new ArrayBuffer(8);
    let uint_x_view = new DataView(uint_x_buffer);
    let uint_y_view = new DataView(uint_y_buffer);
    uint_x_view.setBigUint64(0, uint_x);
    uint_y_view.setBigUint64(0, uint_y);
    let lon = uint_x_view.getFloat64(0);
    let lat = uint_y_view.getFloat64(0);
    return {
        lon,
        lat
    };
}
export function WGS84ToLocal(lon: number, lat: number, offset_x: string, offset_y: string, utm_zone: string) {
    if(!offset_x || !offset_y || !utm_zone) return {
        x: 0,
        y: 0
    };
    let wgs_offset = ZCSToWGS84(offset_x, offset_y)
    let utm = WGS84ToUTM(lon, lat, utm_zone);
    let local_x = utm.utm_easting - wgs_offset.lon;
    let local_y = utm.utm_northing - wgs_offset.lat;
    return {
        x: local_x,
        y: local_y
    };
}

export function LocalToWGS84(local_x: number, local_y: number, offset_x: string, offset_y: string, utm_zone: string) {
    let wgs_offset = ZCSToWGS84(offset_x, offset_y)
    let utm_x = local_x + wgs_offset.lon;
    let utm_y = local_y + wgs_offset.lat;
    return UTMtoLL(utm_x, utm_y, utm_zone);
}

export function WGS84ToZCS(lon: number, lat: number) {
    let unit_x_view = new DataView(new ArrayBuffer(8))
    let unit_y_view = new DataView(new ArrayBuffer(8))
    unit_x_view.setFloat64(0, lon);
    unit_y_view.setFloat64(0, lat);
    let uint_lon = unit_x_view.getBigUint64(0);
    let uint_lat = unit_y_view.getBigUint64(0);
    let lon_xor_factor = ((uint_lat & kZcsBitMask32) << kZcsBitCount32);
    let lat_xor_factor = ((uint_lon & kZcsBitMask32) << kZcsBitCount32);
    uint_lon ^= (kZcsEncryptSalt ^ lon_xor_factor);
    uint_lat ^= (kZcsEncryptSalt ^ lat_xor_factor);
    let zcs_x = (BigInt.asUintN(64, bswap_64(uint_lon))).toString();
    let zcs_y = (BigInt.asUintN(64, bswap_64(uint_lat))).toString();
    return {
        zcs_x, zcs_y
    };
}

export function LocalToZCS(local_x: number, local_y: number, offset_x: string, offset_y: string, utm_zone: string) {
    let wgs = LocalToWGS84(local_x, local_y, offset_x, offset_y, utm_zone);
    return WGS84ToZCS(wgs.lon, wgs.lat);
}

export function ZCSToLocal(zcs_x: string, zcs_y: string, offset_x: string, offset_y: string, utm_zone: string) {
    let wgs = ZCSToWGS84(zcs_x, zcs_y);
    return WGS84ToLocal(wgs.lon, wgs.lat, offset_x, offset_y, utm_zone);
}


export function transfer(point: any, mapMeta: any, offset_x: any, offset_y: any, utm_zone: any) {
    let local_x = point.x;
    let local_y = point.y;

    let offset_x_source = offset_x;
    let offset_y_source = offset_y;
    let utm_zone_source = utm_zone;

    let offset_x_target = mapMeta.offsetX;
    let offset_y_target = mapMeta.offsetY;
    let utm_zone_target = mapMeta.utmZone;

    if (utm_zone_target == utm_zone_source) {
        let wgs_offset_source = ZCSToWGS84(offset_x_source, offset_y_source)
        let wgs_offset_target = ZCSToWGS84(offset_x_target, offset_y_target);
        // offset的差值就是坐标需要平移的量
        const offset_diff_x = wgs_offset_source.lon - wgs_offset_target.lon;
        const offset_diff_y = wgs_offset_source.lat - wgs_offset_target.lat;

        // let uint_x_source = BigInt.asUintN(64, bswap_64(offset_x_source));
        // let uint_y_source = BigInt.asUintN(64, bswap_64(offset_y_source));
        // let uint_x_target = BigInt.asUintN(64, bswap_64(offset_x_target));
        // let uint_y_target = BigInt.asUintN(64, bswap_64(offset_y_target));
        // let x_diff = uint_x_source - uint_x_target;
        // let y_diff = uint_y_source - uint_y_target;
        return {
            x: local_x + offset_diff_x,
            y: local_y +offset_diff_y
        }
    } else {
        let lonlat = LocalToWGS84(local_x, local_y, offset_x_source, offset_y_source, utm_zone_source);
        let local = WGS84ToLocal(lonlat.lon, lonlat.lat, offset_x_target, offset_y_target, utm_zone_target)
        return local
    }
}

export function GCJ02ToLocal(gcj_lon: number, gcj_lat: number, offset_x: string, offset_y: string, utm_zone: string) {
    const wgs = GCJ02ToWGS84(gcj_lon, gcj_lat);
    return WGS84ToLocal(wgs.lon, wgs.lat, offset_x, offset_y, utm_zone);
}

export function WGS84ToGCJ02(lon: number, lat: number): { lon: number; lat: number } {
    if (isOutOfChina(lon, lat)) {
        return { lon, lat };
    }
    const x = lon - 105.0;
    const y = lat - 35.0;
    const kEarthRadius = 6378245.0;
    const kEccentricitySquare = 0.00669342162296594323;
    const longitudeShift =
        300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x)) +
        (2.0 * Math.sin(x * 6.0 * Math.PI) + 2.0 * Math.sin(x * 2.0 * Math.PI) + 2.0 * Math.sin(x * Math.PI) +
         4.0 * Math.sin(x / 3.0 * Math.PI) + 15.0 * Math.sin(x / 12.0 * Math.PI) +
         30.0 * Math.sin(x / 30.0 * Math.PI)) * 20.0 / 3.0;
    const latitudeShift =
        -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x)) +
        (2.0 * Math.sin(x * 6.0 * Math.PI) + 2.0 * Math.sin(x * 2.0 * Math.PI) + 2.0 * Math.sin(y * Math.PI) +
         4.0 * Math.sin(y / 3.0 * Math.PI) + 16.0 * Math.sin(y / 12.0 * Math.PI) +
         32.0 * Math.sin(y / 30.0 * Math.PI)) * 20.0 / 3.0;
    const latRadian = lat / 180.0 * Math.PI;
    const sqrtMagic = Math.sqrt(1.0 - kEccentricitySquare * Math.sin(latRadian) * Math.sin(latRadian));
    const lonArcLength = (Math.PI / 180.0) * (kEarthRadius * Math.cos(latRadian)) / sqrtMagic;
    const latArcLength = (Math.PI / 180.0) * (kEarthRadius * (1 - kEccentricitySquare)) /
        (sqrtMagic * sqrtMagic * sqrtMagic);
    return {
        lon: lon + longitudeShift / lonArcLength,
        lat: lat + latitudeShift / latArcLength,
    };
}

export function GCJ02ToWGS84(gcj_lon: number, gcj_lat: number): { lon: number; lat: number } {
    if (isOutOfChina(gcj_lon, gcj_lat)) {
        return { lon: gcj_lon, lat: gcj_lat };
    }
    const kEpsilon = 1e-10;
    const kNumIterations = 10;
    let curLon = gcj_lon;
    let curLat = gcj_lat;
    for (let i = 0; i < kNumIterations; ++i) {
        const gcj = WGS84ToGCJ02(curLon, curLat);
        const lonDiff = gcj_lon - gcj.lon;
        const latDiff = gcj_lat - gcj.lat;
        curLon += lonDiff;
        curLat += latDiff;
        if (Math.abs(lonDiff) < kEpsilon && Math.abs(latDiff) < kEpsilon) {
            break;
        }
    }
    return { lon: curLon, lat: curLat };
}

//#endregion

//#region  private fuction
function UTMtoLL(utm_easting: number, utm_northing: number, utm_zone: string) {
    let x = utm_easting - 500000.0;
    let y = utm_northing;
    let zone_letter = findNonDigit(utm_zone);
    let zone_number = parseInt(utm_zone, 10);

    if ((zone_letter.charCodeAt(0) - 'N'.charCodeAt(0)) < 0) {
        y -= SOUTH_HEMISPHERE_OFFSET;
    }
    let long_origin = (zone_number - 1.0) * 6.0 - 180.0 + 3.0;
    let ecc_squared = UTM_E2;
    let ecc_prime_squared = (ecc_squared) / (1.0 - ecc_squared);
    let param_k = UTM_K0;
    let wgs84_a = WGS84_A;
    let tmp_m = y / param_k;
    let mu = tmp_m / (wgs84_a * (1.0 - ecc_squared / 4.0 - 3.0 * ecc_squared * ecc_squared / 64.0 - 5.0 * ecc_squared * ecc_squared * ecc_squared / 256.0));
    let e1 = (1 - Math.sqrt(1.0 - ecc_squared)) / (1 + Math.sqrt(1.0 - ecc_squared));
    let phi1_rad = mu + (3.0 * e1 / 2.0 - 27.0 * e1 * e1 * e1 / 32.0) * Math.sin(2.0 * mu) + (21.0 * e1 * e1 / 16.0 - 55.0 * e1 * e1 * e1 * e1 / 32.0) * Math.sin(4.0 * mu) + (151.0 * e1 * e1 * e1 / 96.0) * Math.sin(6.0 * mu);
    let n1 = wgs84_a / Math.sqrt(1.0 - ecc_squared * Math.sin(phi1_rad) * Math.sin(phi1_rad));
    let t1 = Math.tan(phi1_rad) * Math.tan(phi1_rad);
    let c1 = ecc_prime_squared * Math.cos(phi1_rad) * Math.cos(phi1_rad);
    let r1 = wgs84_a * (1.0 - ecc_squared) / Math.pow(1.0 - ecc_squared * Math.sin(phi1_rad) * Math.sin(phi1_rad), 1.5);
    let d = x / (n1 * param_k);
    let lat_rad = phi1_rad - (n1 * Math.tan(phi1_rad) / r1) * (d * d / 2.0 - (5.0 + 3.0 * t1 + 10.0 * c1 - 4.0 * c1 * c1 - 9.0 * ecc_prime_squared) * d * d * d * d / 24.0 + (61.0 + 90.0 * t1 + 298.0 * c1 + 45.0 * t1 * t1 - 252.0 * ecc_prime_squared - 3.0 * c1 * c1) * d * d * d * d * d * d / 720.0);
    let lon_rad = (d - (1.0 + 2.0 * t1 + c1) * d * d * d / 6.0 + (5.0 - 2.0 * c1 + 28.0 * t1 - 3.0 * c1 * c1 + 8.0 * ecc_prime_squared + 24.0 * t1 * t1) * d * d * d * d * d / 120.0) / Math.cos(phi1_rad);
    let lat = lat_rad * DEGREES_PER_RADIAN;
    let lon = long_origin + lon_rad * DEGREES_PER_RADIAN;
    return {
        lon, lat
    }
}

function WGS84ToUTM(lon: number, lat: number, utm_zone: string) {
    return LLtoUTM(lon, lat, utm_zone);
}

function bswap_64(value_string: any) {
    let value = BigInt(value_string);;
    value = (value & 0x00000000FFFFFFFFn) << 32n | (value & 0xFFFFFFFF00000000n) >> 32n;
    value = (value & 0x0000FFFF0000FFFFn) << 16n | (value & 0xFFFF0000FFFF0000n) >> 16n;
    value = (value & 0x00FF00FF00FF00FFn) << 8n | (value & 0xFF00FF00FF00FF00n) >> 8n;
    return value;
}

/**
 * 根据维度划分区域，返回一个字符；
 * @param {*} lat 
 * @returns 
 */
function UTMLetterDesignator(lat: number) {
    let letter_designator;
    if ((84 >= lat) && (lat >= 72)) {
        letter_designator = 'X';
    } else if ((72 > lat) && (lat >= 64)) {
        letter_designator = 'W';
    } else if ((64 > lat) && (lat >= 56)) {
        letter_designator = 'V';
    } else if ((56 > lat) && (lat >= 48)) {
        letter_designator = 'U';
    } else if ((48 > lat) && (lat >= 40)) {
        letter_designator = 'T';
    } else if ((40 > lat) && (lat >= 32)) {
        letter_designator = 'S';
    } else if ((32 > lat) && (lat >= 24)) {
        letter_designator = 'R';
    } else if ((24 > lat) && (lat >= 16)) {
        letter_designator = 'Q';
    } else if ((16 > lat) && (lat >= 8)) {
        letter_designator = 'P';
    } else if ((8 > lat) && (lat >= 0)) {
        letter_designator = 'N';
    } else if ((0 > lat) && (lat >= -8)) {
        letter_designator = 'M';
    } else if ((-8 > lat) && (lat >= -16)) {
        letter_designator = 'L';
    } else if ((-16 > lat) && (lat >= -24)) {
        letter_designator = 'K';
    } else if ((-24 > lat) && (lat >= -32)) {
        letter_designator = 'J';
    } else if ((-32 > lat) && (lat >= -40)) {
        letter_designator = 'H';
    } else if ((-40 > lat) && (lat >= -48)) {
        letter_designator = 'G';
    } else if ((-48 > lat) && (lat >= -56)) {
        letter_designator = 'F';
    } else if ((-56 > lat) && (lat >= -64)) {
        letter_designator = 'E';
    } else if ((-64 > lat) && (lat >= -72)) {
        letter_designator = 'D';
    } else if ((-72 > lat) && (lat >= -80)) {
        letter_designator = 'C';
    } else {
        letter_designator = 'Z';
    }
    return letter_designator;
}

function findNonDigit(str: string) {
    // 遍历字符串中的每个字符
    for (let i = 0; i < str.length; i++) {
        // 如果当前字符不是数字，则返回其索引
        if (isNaN(Number(str[i]))) {
            return str[i];
        }
    }
    // 如果字符串中所有字符都是数字，则返回字符串长度
    return '';
}

function LLtoUTM(lon: number, lat: number, utm_zone: string) {
    let long_temp = (lon + 180.0) - Math.floor((lon + 180.0) / 360.0) * 360.0 - 180.0;
    let zone_number = 0;
    zone_number = toZoneNum(utm_zone);
    return LLtoUTMCore(long_temp, lat, zone_number);
}

function toZoneNum(utmZone: string) {
    let zoneNum = null;
    let pos = 0;
    const zoneStrSize = utmZone.length;

    for (let i = 0; i < zoneStrSize; ++i) {
        const num = utmZone[i];
        if (num >= '0' && num <= '9') {
            ++pos;
        } else {
            break;
        }
    }

    if (zoneStrSize !== (pos + 1)) {
        console.warn("Utm zone is invalid:", utmZone);
        return 0;
    }

    const zoneNumStr = utmZone.substring(0, pos);
    zoneNum = parseInt(zoneNumStr);
    return zoneNum;
}
function LLtoUTMCore(lon: number, lat: number, zone_number: number) {

    let long_origin = (zone_number - 1) * 6 - 180 + 3;
    let long_origin_rad = long_origin * RADIANS_PER_DEGREE;

    let ecc_squared = UTM_E2;
    let ecc_prime_squared = (ecc_squared) / (1 - ecc_squared);
    let wgs84_a = WGS84_A;
    let lat_rad = lat * RADIANS_PER_DEGREE;
    let tmp_n = wgs84_a / Math.sqrt(1.0 - ecc_squared * Math.sin(lat_rad) * Math.sin(lat_rad));
    let tmp_t = Math.tan(lat_rad) * Math.tan(lat_rad);
    let tmp_c = ecc_prime_squared * (lat_rad) * Math.cos(lat_rad);
    let lon_rad = lon * RADIANS_PER_DEGREE;
    let tmp_a = Math.cos(lat_rad) * (lon_rad - long_origin_rad);
    let tmp_m = wgs84_a * ((1.0 - ecc_squared / 4.0 - 3.0 * ecc_squared * ecc_squared / 64.0 -
        5.0 * ecc_squared * ecc_squared * ecc_squared / 256.0) *
        lat_rad -
        (3.0 * ecc_squared / 8.0 + 3.0 * ecc_squared * ecc_squared / 32.0 + 45.0 * ecc_squared * ecc_squared * ecc_squared / 1024.0) * Math.sin(2 * lat_rad) + (15.0 * ecc_squared * ecc_squared / 256.0 + 45.0 * ecc_squared * ecc_squared * ecc_squared / 1024.0) * Math.sin(4 * lat_rad) - (35.0 * ecc_squared * ecc_squared * ecc_squared / 3072.0) * Math.sin(6.0 * lat_rad));
    let param_k = UTM_K0;
    let utm_easting = param_k * tmp_n * (tmp_a + (1.0 - tmp_t + tmp_c) * tmp_a * tmp_a * tmp_a / 6.0 + (5.0 - 18.0 * tmp_t + tmp_t * tmp_t + 72.0 * tmp_c - 58.0 * ecc_prime_squared) * tmp_a * tmp_a * tmp_a * tmp_a * tmp_a / 120.0) + 500000.0;
    let utm_northing = param_k * (tmp_m + tmp_n * Math.tan(lat_rad) *
        (tmp_a * tmp_a / 2.0 + (5.0 - tmp_t + 9.0 * tmp_c + 4.0 * tmp_c * tmp_c) * tmp_a * tmp_a * tmp_a * tmp_a / 24.0 + (61.0 - 58.0 * tmp_t + tmp_t * tmp_t + 600.0 * tmp_c - 330.0 * ecc_prime_squared) * tmp_a * tmp_a * tmp_a * tmp_a * tmp_a * tmp_a / 720.0));
    if (lat < 0) {
        utm_northing += SOUTH_HEMISPHERE_OFFSET;
    }
    return {
        utm_easting,
        utm_northing
    }
}


function isOutOfChina(lon: number, lat: number): boolean {
    return lon < 72.004 || lon > 137.8347 || lat < 0.8293 || lat > 55.8271;
}


//#endregion

//#region delete
function LLtoUTM_old(lon: number, lat: number) {
    let long_temp = (lon + 180) - parseInt((lon + 180) / 360) * 360 - 180;
    let zone_number = parseInt((long_temp + 180) / 6) + 1;
    if (lat >= 56.0 && lat < 64.0 && long_temp >= 3.0 && long_temp < 12.0) {
        zone_number = 32;
    }
    if (lat >= 72.0 && lat < 84.0) {
        if (long_temp >= 0.0 && long_temp < 9.0) {
            zone_number = 31;
        } else if (long_temp >= 9.0 && long_temp < 21.0) {
            zone_number = 33;
        } else if (long_temp >= 21.0 && long_temp < 33.0) {
            zone_number = 35;
        } else if (long_temp >= 33.0 && long_temp < 42.0) {
            zone_number = 37;
        }
    }
    let long_origin = (zone_number - 1) * 6 - 180 + 3;
    let long_origin_rad = long_origin * RADIANS_PER_DEGREE;
    let utm_letter = UTMLetterDesignator(lat);
    let utm_zone = zone_number.toString() + utm_letter;
    let ecc_squared = UTM_E2;
    let ecc_prime_squared = (ecc_squared) / (1 - ecc_squared);
    let wgs84_a = WGS84_A;
    let lat_rad = lat * RADIANS_PER_DEGREE;
    let tmp_n = wgs84_a / Math.sqrt(1.0 - ecc_squared * Math.sin(lat_rad) * Math.sin(lat_rad));
    let tmp_t = Math.tan(lat_rad) * Math.tan(lat_rad);
    let tmp_c = ecc_prime_squared * (lat_rad) * Math.cos(lat_rad);
    let lon_rad = long_temp * RADIANS_PER_DEGREE;
    let tmp_a = Math.cos(lat_rad) * (lon_rad - long_origin_rad);
    let tmp_m = wgs84_a * ((1.0 - ecc_squared / 4.0 - 3.0 * ecc_squared * ecc_squared / 64.0 -
        5.0 * ecc_squared * ecc_squared * ecc_squared / 256.0) *
        lat_rad -
        (3.0 * ecc_squared / 8.0 + 3.0 * ecc_squared * ecc_squared / 32.0 + 45.0 * ecc_squared * ecc_squared * ecc_squared / 1024.0) * Math.sin(2 * lat_rad) + (15.0 * ecc_squared * ecc_squared / 256.0 + 45.0 * ecc_squared * ecc_squared * ecc_squared / 1024.0) * Math.sin(4 * lat_rad) - (35.0 * ecc_squared * ecc_squared * ecc_squared / 3072.0) * Math.sin(6.0 * lat_rad));
    let param_k = UTM_K0;
    let utm_easting = param_k * tmp_n * (tmp_a + (1.0 - tmp_t + tmp_c) * tmp_a * tmp_a * tmp_a / 6.0 + (5.0 - 18.0 * tmp_t + tmp_t * tmp_t + 72.0 * tmp_c - 58.0 * ecc_prime_squared) * tmp_a * tmp_a * tmp_a * tmp_a * tmp_a / 120.0) + 500000.0;
    let utm_northing = param_k * (tmp_m + tmp_n * Math.tan(lat_rad) *
        (tmp_a * tmp_a / 2.0 + (5.0 - tmp_t + 9.0 * tmp_c + 4.0 * tmp_c * tmp_c) * tmp_a * tmp_a * tmp_a * tmp_a / 24.0 + (61.0 - 58.0 * tmp_t + tmp_t * tmp_t + 600.0 * tmp_c - 330.0 * ecc_prime_squared) * tmp_a * tmp_a * tmp_a * tmp_a * tmp_a * tmp_a / 720.0));
    if (lat < 0) {
        utm_northing += SOUTH_HEMISPHERE_OFFSET;
    }
    return {
        utm_easting,
        utm_northing
    }
}
//#endregion